
import { Button } from "@/components/ui/button"

type UserFormActionsProps = {
  loading: boolean
}

export function UserFormActions({ loading }: UserFormActionsProps) {
  return (
    <Button type="submit" className="w-full" disabled={loading}>
      {loading ? "Salvando..." : "Salvar"}
    </Button>
  )
}
